import { FaChartBar, FaTimes } from "react-icons/fa"
import SearchIcon from "@mui/icons-material/Search"
import { Button } from "@mui/material"
import { toast } from "react-toastify"
import { useEffect, useState, useRef, useMemo } from "react"
import { BACKEND } from "../config/configEnvs"
import axios from "axios"
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen"
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen"
import ItemRowDasboardLead from "../components/dasboardLeads/ItemRowDasboardLead"
import { getTodayWithHours } from "../utils/GetDates"
import React from "react"
import { GetDynamicColor } from "../utils/GetTextColor"
import { useSelector } from "react-redux"

const DashboardLeads = () => {

  const user = useSelector((state) => state.auth.user)

  const [leadEvents, setLeadEvents] = useState([])  
  const [groupedEvents, setGroupedEvents] = useState({})
  const [workerKPIs, setWorkerKPIs] = useState({})
  const [valoresKPIs, setValoresKPIs] = useState([])

  const valorPerdidaLead = valoresKPIs.find((kpi) => kpi.subestado === 'Llamada perdida')?.valor || 0
  const valorLlamadaCorta = valoresKPIs.find((kpi) => kpi.subestado === 'Llamada corta')?.valor || 0
  const valorLlamadaFria = valoresKPIs.find((kpi) => kpi.subestado === 'Llamada fria')?.valor || 0
  const valorLlamadaAtendida = valoresKPIs.find((kpi) => kpi.subestado === 'Llamada atendida')?.valor || 0
  const valorMeetCancelado = valoresKPIs.find((kpi) => kpi.subestado === 'Meet cancelado')?.valor || 0
  const valorMeetReagendado = valoresKPIs.find((kpi) => kpi.subestado === 'Meet reagendado')?.valor || 0
  const valorMeetAgendado = valoresKPIs.find((kpi) => kpi.subestado === 'Meet agendado')?.valor || 0
  const valorMeetAtendido = valoresKPIs.find((kpi) => kpi.subestado === 'Meet atendido')?.valor || 0
  const valorExito = valoresKPIs.find((kpi) => kpi.subestado === 'Exito')?.valor || 0
  const valorEvaluandoOpciones = valoresKPIs.find((kpi) => kpi.subestado === 'Evaluando opciones')?.valor || 0
  const valorParaElFuturo = valoresKPIs.find((kpi) => kpi.subestado === 'Para el futuro')?.valor || 0
  const valorFrio = valoresKPIs.find((kpi) => kpi.subestado === 'Frio')?.valor || 0
  const valorPorConfirmarDeposito = valoresKPIs.find((kpi) => kpi.subestado === 'Por confirmar depósito')?.valor || 0
  const valorCurioso = valoresKPIs.find((kpi) => kpi.subestado === 'Curioso')?.valor || 0
  const valorNoResponde = valoresKPIs.find((kpi) => kpi.subestado === 'No responde')?.valor || 0
  const valorElServicioLePareceCaro = valoresKPIs.find((kpi) => kpi.subestado === 'El servicio le parece caro')?.valor || 0
  const valorDecidióTrabajarConOtraAgencia = valoresKPIs.find((kpi) => kpi.subestado === 'Decidió trabajar con otra agencia')?.valor || 0
  const valorDecidióTrabajarConUnFreelancer = valoresKPIs.find((kpi) => kpi.subestado === 'Decidió trabajar con un freelancer')?.valor || 0
  const valorNoEstaEnMiCiudad = valoresKPIs.find((kpi) => kpi.subestado === 'No esta en mi ciudad')?.valor || 0
  const valorCompetenciaOsospechoso = valoresKPIs.find((kpi) => kpi.subestado === 'Competencia o sospechoso')?.valor || 0
  const valorLeadConPocoPresupuesto = valoresKPIs.find((kpi) => kpi.subestado === 'Lead con poco presupuesto')?.valor || 0

  const { start, end } = getTodayWithHours()
  const [startDate, setStartDate] = useState(start)
  const [endDate, setEndDate] = useState(end)

  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION"
  const selectedUserForAdmin = !isAdmin ? user.id : ""
  
  const [leadName, setLeadName] = useState("")
  const [leadStatus, setLeadStatus] = useState("")

  const [sellers, setSellers] = useState([])
  const [selectedSeller, setSelectedSeller] = useState(selectedUserForAdmin)
  const [selectedSellers, setSelectedSellers] = useState([])

  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(20)
  const [searchCriteria, setSearchCriteria] = useState("leadName")
  const [events, setEvents] = useState([])

  const [loadingStatus, setLoadingStatus] = useState(false)
  const [totalDocs, setTotalDocs] = useState(0)
  const [totalPages, setTotalPages] = useState(0)

  const ColorMap = {
    "Lead": "text-yellow-400",
    "Prospecto": "text-blue-500",
    "Cliente": "text-green-500",
  }

  const ColorMapKPIs = [
    { min: 0, max: 25, color: "text-red-500" },
    { min: 25, max: 50, color: "text-yellow-400" },
    { min: 50, max: 75, color: "text-green-500" },
    { min: 75, max: 1000, color: "text-blue-500" }
  ];

  const getValoresKPIs = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/reglasValoresKPIs?limit=0`)
      setValoresKPIs(response.data.docs)
    } catch (e) {
      toast.error("No se pudieron obtener los valores de los KPIs: " + e)
    }
  }

  const getLeadEvents = async () => {
    try {
      setLoadingStatus(true)
      setWorkerKPIs({}) // Reset KPIs when fetching new data

      let url = `${BACKEND}/api/eventosLeads?limit=0`

      let andFilters = [];

      if (startDate) {
        const adjustedStartDate = new Date(startDate);
        adjustedStartDate.setHours(adjustedStartDate.getHours() + 5);
        andFilters.push({
          createdAt: {
            greater_than_equal: adjustedStartDate?.toISOString(),
          }
        })
      }
    
      if (endDate) {
        const adjustedEndDate = new Date(endDate);
        adjustedEndDate.setHours(adjustedEndDate.getHours() + 29);
        andFilters.push({
          createdAt: {
            less_than_equal: adjustedEndDate?.toISOString(),
          }
        })
      }

      if (leadName) {
        if (searchCriteria === "leadName") {
          url += `&where[lead.leadName][like]=${leadName}`
        } else if (searchCriteria === "phone") {
          url += `&where[lead.phone][like]=${leadName}`
        } else if (searchCriteria === "dni") {
          url += `&where[lead.dni][like]=${leadName}`
        } else if (searchCriteria === "id") {
          url += `&where[lead][equals]=${leadName}`
        }
      }

      if (leadStatus) {
        url += `&where[lead.status][equals]=${leadStatus}`
      }

      if (selectedSeller) {
        url += `&where[seller][equals]=${selectedSeller}`
      }

      if (andFilters.length > 0) {
        andFilters.forEach((filter, index) => {
          const key = `where[and][${index}][${Object.keys(filter)[0]}][${Object.keys(filter[Object.keys(filter)[0]])[0]}]`;
          const value = Object.values(Object.values(filter)[0])[0];
          url += `&${key}=${value}`;
        });
      }

      const response = await axios.get(url)
      setEvents(response.data.docs)

      const grouped = groupEventsByDayAndLead(response.data.docs);
      setGroupedEvents(grouped);

      const processedEvents = response.data.docs.map(event => ({
        ...event,
        displayDate: new Date(event.createdAt).toLocaleString('es-PE', {
          timeZone: 'America/Lima',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        })
      }));

      setLeadEvents(processedEvents)
      
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)
    } catch (e) {
      toast.error(e)
    } finally {
      setLoadingStatus(false)
    }
  }

  // Función para agrupar eventos por día y por lead
  const groupEventsByDayAndLead = (events) => {
    const grouped = {};
    
    events.forEach(event => {
      // Convertir la fecha UTC a GMT-5
      const utcDate = new Date(event.createdAt);
      const localDate = new Date(utcDate.getTime() - (5 * 60 * 60 * 1000));
      // Obtener la fecha en formato YYYY-MM-DD en hora local
      const date = localDate.toISOString().split('T')[0];
      
      // Obtener el ID del lead y del vendedor
      const leadId = event.lead?.id || 'unknown';
      const sellerId = event.lead?.responsible?.id || 'unknown';
      
      // Crear una clave única combinando lead y vendedor
      const uniqueKey = `${leadId}-${sellerId}`;
      
      // Si no existe el día, crearlo
      if (!grouped[date]) {
        grouped[date] = {};
      }
      
      // Si no existe el lead-vendedor para este día, crearlo
      if (!grouped[date][uniqueKey]) {
        grouped[date][uniqueKey] = {
          lead: event.lead,
          seller: event.seller,
          events: []
        };
      }
      
      // Agregar el evento al lead-vendedor correspondiente
      grouped[date][uniqueKey].events.push({
        ...event,
        // Agregar la fecha local formateada para mostrar
        displayDate: localDate.toLocaleString('es-PE', {
          timeZone: 'America/Lima',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        })
      });
    });
    
    return grouped;
  };

  const getSellers = async () => {
    try {
      let url = `${BACKEND}/api/trabajadores`

      if (!isAdmin) {
        url = `${url}/${selectedUserForAdmin}`
      } else {
        url = `${url}?limit=0&where[activo][equals]=true&where[area][equals]=Comercial`
      }

      const response = await axios.get(url);
      const sellers = response.data.docs.filter((v) => v.area.toUpperCase() === "COMERCIAL")
      setSellers(sellers)

    } catch (e) {
      toast.error(e)
    }
  };

  const handleResetSearch = () => {
    setLeadName("")
  }

  const handleSearchClients = () => {
    setPage(1)
    getLeadEvents()
  }

  useEffect(() => {
    if (leadName === "") {
      getLeadEvents(); 
      setPage(1);
    }
  }, [leadName]);

  const debounceUpdate = useRef(null); // Referencia para mantener el debouncer
  
  useEffect(() => {
    if (debounceUpdate.current) {
      clearTimeout(debounceUpdate.current);
    }
    debounceUpdate.current = setTimeout(async () => {
      setWorkerKPIs({}) // Reset KPIs when filters change
      getLeadEvents()
    }, 1500);
  }, [selectedSellers])
  

  useEffect(() => {
    setWorkerKPIs({})
    getLeadEvents()  
  }, [page, limit, leadStatus, startDate, endDate, selectedSeller])

  useEffect(() => {
    getSellers()
    getValoresKPIs()
  }, [])

  const ITEM_HEIGHT = 48;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 6.5,
        width: 200,
      },
    },
  };

  const handleWorkerKPI = (workerId, kpi) => {
    setWorkerKPIs(prev => ({
      ...prev,
      [workerId]: (prev[workerId] || 0) + kpi
    }));
  };

  const [globalValues, setGlobalValues] = useState({
    proyectadas: 0,
    vendidas: 0
  });

  const eventosLlamadas = leadEvents.filter(e => e.eventType === "Llamada")
  const eventosMeets = leadEvents.filter(e => e.eventType === "Google Meet")
  const eventosCotizaciones = useMemo(() => {
    return leadEvents.filter(e => e.eventType === "Cambio estado cotización");
  }, [leadEvents]);
  const eventosEntradas = leadEvents.filter(e => e.eventType === "Entrada al sistema")

  // Llamadas
  const llamadasPerdidas = eventosLlamadas.filter(e => e.eventSubType === "Llamada perdida").length
  const llamadasCortas = eventosLlamadas.filter(e => e.eventSubType === "Llamada corta").length
  const llamadasFrias = eventosLlamadas.filter(e => e.eventSubType === "Llamada fria").length
  const llamadasAtendidas = eventosLlamadas.filter(e => e.eventSubType === "Llamada atendida").length

  // Meets
  const meetsPerdidos = eventosMeets.filter(e => e.eventSubType === "Meet cancelado").length
  const meetsAgendados = eventosMeets.filter(e => e.eventSubType === "Meet agendado").length
  const meetsAtendidos = eventosMeets.filter(e => e.eventSubType === "Meet atendido").length
  const meetsReagendados = eventosMeets.filter(e => e.eventSubType === "Meet reagendado").length

  // Cotizaciones
  const cotizacionesEvaluandoOpciones = eventosCotizaciones.filter(e => e.eventType === "Cambio estado cotización" && e.eventSubType === "Evaluando opciones").length
  const cotizacionesFrio = eventosCotizaciones.filter(e => e.eventType === "Cambio estado cotización" && e.eventSubType === "Frio").length
  const cotizacionesParaElFuturo = eventosCotizaciones.filter(e => e.eventType === "Cambio estado cotización" && e.eventSubType === "Para el futuro").length
  const cotizacionesPorConfirmarDeposito = eventosCotizaciones.filter(e => e.eventType === "Cambio estado cotización" && e.eventSubType === "Por confirmar depósito").length

  const cotizacionesCurioso = eventosCotizaciones.filter(e => e.eventType === "Cambio estado cotización" && e.eventSubType === "Curioso").length
  const cotizacionesNoResponde = eventosCotizaciones.filter(e => e.eventType === "Cambio estado cotización" && e.eventSubType === "No responde").length
  const cotizacionElServicioLePareceCaro = eventosCotizaciones.filter(e => e.eventType === "Cambio estado cotización" && e.eventSubType === "El servicio le parece caro").length
  const cotizacionesDecidioTrabajarConOtraAgencia = eventosCotizaciones.filter(e => e.eventType === "Cambio estado cotización" && e.eventSubType === "Decidió trabajar con otra agencia").length
  const cotizacionesDecidioTrabajarConUnFreelancer = eventosCotizaciones.filter(e => e.eventType === "Cambio estado cotización" && e.eventSubType === "Decidió trabajar con un freelancer").length
  const cotizacionesCompetenciaOsospechoso = eventosCotizaciones.filter(e => e.eventType === "Cambio estado cotización" && e.eventSubType === "Competencia o sospechoso").length
  const cotizacionesLeadConPocoPresupuesto = eventosCotizaciones.filter(e => e.eventType === "Cambio estado cotización" && e.eventSubType === "Lead con poco presupuesto").length
  const cotizacionesNoEstaEnMiCiudad = eventosCotizaciones.filter(e => e.eventType === "Cambio estado cotización" && e.eventSubType === "No esta en mi ciudad").length

  const cotizacionesEnExito = eventosCotizaciones.filter(e => e.eventType === "Cambio estado cotización" && e.eventSubType === "Exito").length

  useEffect(() => {
    const ventasProyectadas = eventosCotizaciones
      .filter(evento => 
        evento.eventType === "Cambio estado cotización" && 
        ["Frio", "Evaluando opciones", "Por confirmar depósito", "Para el futuro"].includes(evento.eventSubType) &&
        evento.quote?.estado === "En espera"
      )
      .reduce((acc, evento) => acc + (evento.quote?.precioTotalSinIGV || 0), 0);

    const ventasRealizadas = eventosCotizaciones
      .filter(evento => 
        evento.eventType === "Cambio estado cotización" && 
        evento.eventSubType === "Exito" &&
        evento.quote?.estado === "Exito"
      )
      .reduce((acc, evento) => acc + (evento.quote?.precioTotalSinIGV || 0), 0);

    setGlobalValues(prev => ({
      ...prev,
      proyectadas: ventasProyectadas,
      vendidas: ventasRealizadas
    }));
  }, [eventosCotizaciones]);

  return (
    <div className="flex flex-col h-screen w-full">

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto scrollbar-hide">
          
          <div className="flex items-center gap-4 py-4">
            <FaChartBar className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Trazabilidad de leads</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span className="truncate">Buscar por:</span>
              <select
                value={searchCriteria}
                onChange={(e) => setSearchCriteria(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="leadName">Nombre de lead</option>
                <option value="phone">Número de teléfono</option>
                <option value="dni">DNI</option>
                <option value="id">ID</option>
              </select>
            </div>

            <div className="relative w-full">
              <input
                type="text"
                placeholder={`Buscar lead`}
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={leadName}
                onChange={(e) => setLeadName(e.target.value)}
              />
              {leadName && (
                <FaTimes
                  onClick={() => handleResetSearch()}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => handleSearchClients()}
              >
                Buscar
              </Button>
            </div>

          </div>

        </div>
      </div>
      
      {/* Llamadas */}
      <div className="flex bg-gray-100 mt-0.5 w-full gap-10">
        <div className="flex flex-row w-full justify-between gap-8 py-1 px-8">
          <div className="flex flex-row items-center gap-8">
            <span className="text-xs text-gray-500">
              Llamadas perdidas (-30 secs): <span className="font-bold text-red-500">{llamadasPerdidas}</span> / {((llamadasPerdidas / eventosLlamadas.length) * 100).toFixed(1)}%
            </span>

            <span className="text-xs text-gray-500">
              Llamadas cortas (30-60 secs): <span className="font-bold text-yellow-400">{llamadasCortas}</span> / {((llamadasCortas / eventosLlamadas.length) * 100).toFixed(1)}%
            </span>
            
            <span className="text-xs text-gray-500">
              Llamadas frias (60-300 secs): <span className="font-bold text-blue-400">{llamadasFrias}</span> / {((llamadasFrias / eventosLlamadas.length) * 100).toFixed(1)}%
            </span>

            <span className="text-xs text-gray-500">
              Llamadas atendidas (+300 secs): <span className="font-bold text-green-500">{llamadasAtendidas}</span> / {((llamadasAtendidas / eventosLlamadas.length) * 100).toFixed(1)}%
            </span>
          </div>
          <span className="text-xs font-bold text-gray-700">
            Total de llamadas: <span className="text-gray-700">{eventosLlamadas.length}</span>
          </span>
        </div>
      </div>

      {/* Meets */}
      <div className="flex bg-gray-100 mt-0.5 w-full gap-10">
        <div className="flex flex-row w-full items-center justify-between gap-4 py-1 px-8">
          <div className="flex flex-row items-center gap-8">
            <span className="text-xs  text-gray-500">
              Meets perdidos: <span className="text-red-500 font-bold">{meetsPerdidos}</span> / { eventosMeets.length === 0 ? 0 : ((meetsPerdidos / eventosMeets.length) * 100).toFixed(1)}%
            </span>

            <span className="text-xs  text-gray-500">
              Meets agendados: <span className="text-yellow-400 font-bold">{meetsAgendados}</span> / { eventosMeets.length === 0 ? 0 : ((meetsAgendados / eventosMeets.length) * 100).toFixed(1)}%
            </span>
            
            <span className="text-xs  text-gray-500">
              Meets atendidos: <span className="text-blue-400 font-bold">{meetsAtendidos}</span> / { eventosMeets.length === 0 ? 0 : ((meetsAtendidos / eventosMeets.length) * 100).toFixed(1)}%
            </span>

            <span className="text-xs  text-gray-500">
              Meets reagendados: <span className="text-green-500 font-bold">{meetsReagendados}</span> / { eventosMeets.length === 0 ? 0 : ((meetsReagendados / eventosMeets.length) * 100).toFixed(1)}%
            </span> 
          </div>
          <span className="text-xs font-bold text-gray-700">
            Total de Meets: <span className="text-gray-700">{eventosMeets.length}</span>
          </span>
        </div>
      </div>

      {/* Cotizaciones */}
      <div className="flex bg-gray-100 mt-0.5 w-full gap-5 px-4">
        <div className="flex flex-row w-full items-center justify-between gap-4 py-1 px-4">
          <div className="flex flex-row overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] items-center gap-8 whitespace-nowrap scrollbar-hide">

            <span className="text-xs text-gray-500">
              Frio: <span className="text-yellow-400 font-bold">{cotizacionesFrio}</span> / { eventosCotizaciones.length === 0 ? 0 : (cotizacionesFrio / eventosCotizaciones.length * 100).toFixed(1)}%
            </span>

            <span className="text-xs text-gray-500">
              Evaluando opciones: <span className="text-yellow-400 font-bold">{cotizacionesEvaluandoOpciones}</span> / { eventosCotizaciones.length === 0 ? 0 : (cotizacionesEvaluandoOpciones / eventosCotizaciones.length * 100).toFixed(1)}%
            </span>
            
            <span className="text-xs text-gray-500">
              Por confirmar depósito: <span className="text-yellow-400 font-bold">{cotizacionesPorConfirmarDeposito}</span> / { eventosCotizaciones.length === 0 ? 0 : (cotizacionesPorConfirmarDeposito / eventosCotizaciones.length * 100).toFixed(1)}%
            </span>

            <span className="text-xs text-gray-500">
              Para el futuro: <span className="text-yellow-400 font-bold">{cotizacionesParaElFuturo}</span> / { eventosCotizaciones.length === 0 ? 0 : (cotizacionesParaElFuturo / eventosCotizaciones.length * 100).toFixed(1)}%
            </span> 

            <span className="text-xs text-gray-500">
              Curioso: <span className="text-red-400 font-bold">{cotizacionesCurioso}</span> / { eventosCotizaciones.length === 0 ? 0 : (cotizacionesCurioso / eventosCotizaciones.length * 100).toFixed(1)}%
            </span> 

            <span className="text-xs text-gray-500">
              No responde: <span className="text-red-400 font-bold">{cotizacionesNoResponde}</span> / { eventosCotizaciones.length === 0 ? 0 : (cotizacionesNoResponde / eventosCotizaciones.length * 100).toFixed(1)}%
            </span> 

            <span className="text-xs text-gray-500">
              Le parece caro: <span className="text-red-400 font-bold">{cotizacionElServicioLePareceCaro}</span> / { eventosCotizaciones.length === 0 ? 0 : (cotizacionElServicioLePareceCaro / eventosCotizaciones.length * 100).toFixed(1)}%
            </span> 

            <span className="text-xs text-gray-500">
              Trabajará con otra agencia: <span className="text-red-400 font-bold">{cotizacionesDecidioTrabajarConOtraAgencia}</span> / { eventosCotizaciones.length === 0 ? 0 : (cotizacionesDecidioTrabajarConOtraAgencia / eventosCotizaciones.length * 100).toFixed(1)}%
            </span> 

            <span className="text-xs text-gray-500">
              Trabajará con un freelancer: <span className="text-red-400 font-bold">{cotizacionesDecidioTrabajarConUnFreelancer}</span> / { eventosCotizaciones.length === 0 ? 0 : (cotizacionesDecidioTrabajarConUnFreelancer / eventosCotizaciones.length * 100).toFixed(1)}%
            </span> 

            <span className="text-xs text-gray-500">
              Competencia o sospechoso: <span className="text-red-400 font-bold">{cotizacionesCompetenciaOsospechoso}</span> / { eventosCotizaciones.length === 0 ? 0 : (cotizacionesCompetenciaOsospechoso / eventosCotizaciones.length * 100).toFixed(1)}%
            </span> 
            
            <span className="text-xs text-gray-500">
              Lead con poco presupuesto: <span className="text-red-400 font-bold">{cotizacionesLeadConPocoPresupuesto}</span> / { eventosCotizaciones.length === 0 ? 0 : (cotizacionesLeadConPocoPresupuesto / eventosCotizaciones.length * 100).toFixed(1)}%
            </span> 
            
            <span className="text-xs text-gray-500">
              No está en mi ciudad: <span className="text-red-400 font-bold">{cotizacionesNoEstaEnMiCiudad}</span> / { eventosCotizaciones.length === 0 ? 0 : (cotizacionesNoEstaEnMiCiudad / eventosCotizaciones.length * 100).toFixed(1)}%
            </span>
            
            <span className="text-xs text-gray-500">
              Cotizaciones exito: <span className="text-blue-400 font-bold">{cotizacionesEnExito}</span> / { eventosCotizaciones.length === 0 ? 0 : (cotizacionesEnExito / eventosCotizaciones.length * 100).toFixed(1)}%
            </span>
            
          </div>
          <span className="text-xs font-bold text-gray-700 whitespace-nowrap">
            Total de cotizaciones: <span className="text-gray-700">{eventosCotizaciones.length}</span>
          </span>
        </div>
      </div>

      {/* Agregar una sección para mostrar los valores globales */}
      <div className="flex bg-gray-100 mt-0.5 w-full gap-10 px-8 py-1">
        <div className="flex flex-row items-center justify-between w-full gap-4">
          <span className="text-xs text-gray-700">
            Llamadas totales: <span className="text-gray-700 font-bold"> {eventosLlamadas.length} / {((eventosLlamadas.length / leadEvents.length) * 100).toFixed(1)}% </span> 
          </span>
          <span className="text-xs text-gray-700">
            Meets totales: <span className="text-gray-700 font-bold"> {eventosMeets.length} / {((eventosMeets.length / leadEvents.length) * 100).toFixed(1)}% </span>
          </span>
          <span className="text-xs text-gray-700">
            Total de entradas al sistema: <span className="text-gray-700 font-bold">{eventosEntradas.length} / {((eventosEntradas.length / leadEvents.length) * 100).toFixed(1)}% </span>
          </span>
          <span className="text-xs text-gray-700">
            Cotizaciones totales: <span className="text-gray-700 font-bold"> {eventosCotizaciones.length} / {((eventosCotizaciones.length / leadEvents.length) * 100).toFixed(1)}% </span>
          </span>
        </div>
      </div>

      {/* Resumen de KPIs por trabajador */}
      <div className="flex bg-gray-100 mt-0.5 w-full gap-10 px-8">
        <div className="flex flex-row justify-between w-full items-center gap-4">
          <div className="flex flex-row items-center gap-4">
            {sellers.map(seller => (
              <span key={seller.id}>
                <span className="text-xs text-gray-700">{seller.name} </span>
                <span className={`text-xs font-bold ${GetDynamicColor(workerKPIs[seller.id] || 0, ColorMapKPIs)}`}>
                  {workerKPIs[seller.id]?.toFixed(1) || '0.00'}
                </span>
              </span>
            ))}
          </div>
          <div className="flex flex-row items-center gap-4">
            <span className="text-xs font-bold text-gray-700">
              Puntaje global: <span className="text-gray-700">{Object.values(workerKPIs).reduce((acc, curr) => acc + curr, 0).toFixed(1)}</span>
            </span>
          </div>
        </div>
      </div>

      {/* Ventas proyectadas y realizadas */}
      <div className="flex bg-gray-100 mt-0.5 w-full gap-10">
        <div className="flex flex-row w-full items-center justify-center gap-16 py-1 px-8">
          <span className="text-xs font-bold text-gray-700">
            Ventas proyectadas totales: <span className="text-purple-500">S/. {globalValues.proyectadas.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
          </span>
          <span className="text-xs font-bold text-gray-700">
            Ventas realizadas totales: <span className="text-green-500">S/. {globalValues.vendidas.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
          </span>
        </div>
      </div>

      {/* Barra de filtros */}
      <div className="flex bg-gray-100 mt-0.5 mb-0.5 justify-between  w-full gap-10">
        <div className="flex flex-row w-full justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] gap-4 px-4">
          <div className="flex flex-row items-center justify-between gap-4 px-4">

            {/* Vendedoras */}
            {isAdmin && (
              <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
                <span>Vendedores:</span>
                <select
                  value={selectedSeller}
                  onChange={(e) => setSelectedSeller(e.target.value)}
                  className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                >
                  <option value="">Todos</option>
                  {sellers.map((s) => (
                    <option key={s.id} value={s.id}>{s.name}</option>
                  ))}
                </select>
              </div>
            )}

            {/* Filtro lead status */}
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Estado lead:</span>
              <select
                value={leadStatus}
                onChange={(e) => setLeadStatus(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="">Todos</option>
                <option value="Lead">Lead</option>
                <option value="Prospecto">Prospecto</option>
                <option value="Cliente">Cliente</option>
              </select>
            </div>

            {/* Fechas */}
            <div className="flex flex-row gap-4 items-center justify-start w-full px-4">

              <div className="flex flec-row items-center justify-center gap-2">
                <label className="block text-xs font-medium text-gray-900">
                  Fecha inicio
                </label>

                <div className="flex flex-row items-center justify-center gap-4">
                  <input 
                    type="date" 
                    className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                    value={new Date(startDate).toISOString().split('T')[0]}
                    onChange={(e) => setStartDate(new Date(e.target.value).toISOString())}
                  />
                </div> 
              </div>

              <div className="flex flec-row items-center justify-center gap-2">
                <label className="block text-xs font-medium text-gray-900">
                  Fecha fin
                </label>

                <div className="flex flex-row items-center justify-center gap-4">
                  <input 
                    type="date" 
                    className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                    value={new Date(endDate).toISOString().split('T')[0]}
                    onChange={(e) => setEndDate(new Date(e.target.value).toISOString())}
                  />
                </div> 
              </div>

            </div>  

          </div>
          <div className="flex flex-row items-center justify-center gap-4 px-4">
            <span className="text-xs font-bold text-gray-700">
              Total eventos: <span className="text-gray-700">{leadEvents.length}</span>
            </span>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
            <LoadingScreen />
          ) : (
            leadEvents.length === 0 ? (
              <NoDataScreen />
            ) : (
              <div className="w-full">
                <table className="w-full text-xs">
                  <thead className="text-xs sticky top-0 z-50 text-gray-900 bg-gray-200">
                    <tr className="text-gray-700 text-center text-[10px] font-bold">
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Vendedora
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Usuario
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Detalles usuario
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Estado Usuario
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Teléfono
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Fecha
                      </td>
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        Entrada sistema
                      </td>
                      <td className="px-2 py-3 text-center bg-blue-500 border-r border-r-white text-white border-red">
                        Llamadas perdidas <span className="truncate">(-40 secs)</span>{"\n"}<span className="truncate">{valorPerdidaLead} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-blue-500 border-r border-r-white text-white border-red">
                        Llamadas cortas <span className="truncate">(40-70 secs)</span>{"\n"}<span className="truncate">{valorLlamadaCorta} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-blue-500 border-r border-r-white text-white border-red">
                        Llamadas frias <span className="truncate">(70-300 secs)</span>{"\n"}<span className="truncate">{valorLlamadaFria} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-blue-500 border-r border-r-white text-white border-red">
                        Llamadas atendidas <span className="truncate">(+300 secs)</span>{"\n"}<span className="truncate">{valorLlamadaAtendida} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-green-600 border-r border-r-white text-white border-red">
                        Meet Agendados<span className="truncate"></span>{"\n"}<span className="truncate">{valorMeetAgendado} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-green-600 border-r border-r-white text-white border-red">
                        Meet Atendidos<span className="truncate"></span>{"\n"}<span className="truncate">{valorMeetAtendido} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-green-600 border-r border-r-white text-white border-red">
                        Meet Reagendados<span className="truncate"></span>{"\n"}<span className="truncate">{valorMeetReagendado} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-green-600 border-r border-r-white text-white border-red">
                        Meet Cancelados<span className="truncate"></span>{"\n"}<span className="truncate">{valorMeetCancelado} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-yellow-400 border-r border-r-white text-white border-red">
                        Cotizaciones<span className="truncate block">frio</span>{"\n"}<span className="truncate block">{valorFrio} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-yellow-400 border-r border-r-white text-white border-red">
                        Cotizaciones<span className="truncate block">evaluando </span>opciones{"\n"}<span className="truncate block">{valorEvaluandoOpciones} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-yellow-400 border-r border-r-white text-white border-red">
                        Cotizaciones <span className="truncate block">por confirmar</span>depósito{"\n"}<span className="truncate block">{valorPorConfirmarDeposito} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-yellow-400 border-r border-r-white text-white border-red">
                        Cotizaciones para<span className="truncate block"> el futuro</span>{"\n"}<span className="truncate block">{valorParaElFuturo} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-red-500 border-r border-r-white text-white border-red">
                        Cotizaciones <span className="truncate block">curioso</span>{"\n"}<span className="truncate block">{valorCurioso} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-red-500 border-r border-r-white text-white border-red">
                        Cotizaciones <span className="truncate block">no responde</span>{"\n"}<span className="truncate block">{valorNoResponde} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-red-500 border-r border-r-white text-white border-red">
                        Cotizaciones <span className="truncate block">no esta en</span>  mi ciudad{"\n"}<span className="truncate block">{valorNoEstaEnMiCiudad} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-red-500 border-r border-r-white text-white border-red">
                        Cotizaciones <span className="truncate block">lead con poco</span><span className="truncate block">presupuesto</span>{"\n"}<span className="truncate block">{valorLeadConPocoPresupuesto} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-red-500 border-r border-r-white text-white border-red">
                        Cotizaciones <span className="truncate block">el servicio le </span>parece caro {"\n"}<span className="truncate block">{valorElServicioLePareceCaro} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-red-500 border-r border-r-white text-white border-red">
                        Cotizaciones <span className="truncate block">decidió trabajar</span>{"\n"} <span className="truncate block">con otra agencia</span>{"\n"}<span className="truncate block">{valorDecidióTrabajarConOtraAgencia} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-red-500 border-r border-r-white text-white border-red">
                        Cotizaciones <span className="truncate block">decidió trabajar</span>{"\n"} <span className="truncate block">con un freelancer</span>{"\n"}<span className="truncate block">{valorDecidióTrabajarConUnFreelancer} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-red-500 border-r border-r-white text-white border-red">
                        Cotizaciones <span className="truncate block">competencia o </span>{"\n"} <span className="truncate block">sospechoso</span>{"\n"}<span className="truncate block">{valorCompetenciaOsospechoso} pts</span>
                      </td>
                      <td className="px-2 py-3 text-center bg-blue-800 border-r border-r-white text-white border-red">
                        Venta realizada con exito
                      </td>
                      <td className="px-2 py-3 text-center bg-purple-300 border-r border-r-white text-white border-red">
                        Ventas proyectadas
                      </td>
                      <td className="px-2 py-3 text-center bg-purple-300 border-r border-r-white text-white border-red">
                        Monto venta
                      </td>
                      <td className="px-2 py-3 text-center sticky right-0 shadow-md z-50 bg-purple-300 text-white">
                        Puntaje <span className="truncate block">total (KPI)</span>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(groupedEvents).map(date => (
                      <React.Fragment key={date}>
                        {Object.keys(groupedEvents[date]).map(leadId => {
                          const leadData = groupedEvents[date][leadId];
                          return (
                            <ItemRowDasboardLead 
                              key={`${date}-${leadId}`}
                              date={date}
                              leadData={leadData} 
                              colorMap={ColorMap}
                              setWorkerKPI={handleWorkerKPI}
                              valoresKPIs={valoresKPIs}
                            />
                          );
                        })}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            )
          )
        }
      </div>

    </div>
  )
}

export default DashboardLeads
